import React from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink, useParams } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';

const PREFIX = 'Topbar';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    boxShadow: 'none',
  },
}));

const Topbar = props => {
  const { className, ...rest } = props;
  const theme = useTheme();

  const rootUrl = `${window.location.protocol}//${window.location.host}/app/`;
  return (
    <StyledAppBar {...rest} className={clsx(classes.root, className)} color={theme.appBarColor} position='fixed'>
      <Toolbar>
        <a href={rootUrl} className={classes.logo}>
            <img alt='Logo' src={theme.topLogo} width={theme.topLogoWidth || '100%'} />
        </a>
      </Toolbar>
    </StyledAppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
